export const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM as string;
export const KEYCLOAK_CLIENT_ID = import.meta.env
  .VITE_KEYCLOAK_CLIENT_ID as string;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL as string;
export const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL as string;
export const APP_URL = import.meta.env.VITE_APP_URL as string;

export const DD_PORTAL_URL = import.meta.env.VITE_DD_PORTAL_URL as string;
